"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateParticipants = void 0;
var findQuestion_1 = require("./findQuestion");
function participantMatch(response, participant) {
    var _a;
    if (response.associatedId &&
        participant.participantId === response.associatedId) {
        return true;
    }
    return ((_a = participant.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === response.answer.toLowerCase();
}
function generateParticipants(existingParticipants, responses, sections) {
    var participants = [];
    var _loop_1 = function (response) {
        var question = findQuestion_1.findOrThrowQuestionById(sections, response.questionId).question;
        if (question.subType !== "PARTICIPANT") {
            return "continue";
        }
        if (participants.some(function (p) { return participantMatch(response, p); })) {
            return "continue";
        }
        var existing = existingParticipants.find(function (p) {
            return participantMatch(response, p);
        });
        if (existing) {
            participants.push(existing);
            return "continue";
        }
        participants.push({
            name: response.answer,
            participantId: response.associatedId,
            role: question.participantRole || "ATTENDANT",
            timeAdded: new Date().toISOString(),
        });
    };
    for (var _i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
        var response = responses_1[_i];
        _loop_1(response);
    }
    return participants;
}
exports.generateParticipants = generateParticipants;
//# sourceMappingURL=generateParticipants.js.map